import React from "react";
import { DateField, ReferenceInput, SelectInput, SimpleForm, TextInput } from "react-admin";

const CampaignChallengeForm = (props) => (
	<SimpleForm {...props}>
		<ReferenceInput source="campaign_id" reference="campaign">
			<SelectInput label="Campagne" optionText="abstract_title" />
		</ReferenceInput>
		<ReferenceInput source="challenge_id" reference="challenge">
			<SelectInput label="Défis" optionText="abstract_title" />
		</ReferenceInput>
	</SimpleForm>
);

export default CampaignChallengeForm;
